<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="params.params.baseId" filterable @change="getGroupList(params.params.baseId)"
            placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>区域&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>造次&nbsp;:</label>
          <el-select v-model="params.params.periodId" filterable placeholder="请选择造次">
            <el-option label="全部造次" value=""></el-option>
            <el-option v-for="item in periodList" :key="item.periodId" :label="item.periodName" :value="item.periodId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="params.params.breedTypeId" filterable placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option v-for="item in breedTypeList" :key="item.breedTypeId" :label="item.breedTypeName"
              :value="item.breedTypeId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.breedId" :label="item.breedName" :value="item.breedId">
            </el-option>
          </el-select>
        </div>
        <!-- 年月 -->
        <div class="page-search-date">
          <div class="page-search-item">
            <label>月份&nbsp;:</label>
            <el-date-picker v-model="month" type="month" value-format="yyyy-MM" @change="monthChange" placeholder="请选择月份">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <div><i class="title-icon"></i>水产养殖排塘损失统计表</div>
        <div>单位 : {{ orgName }}</div>
        <div>月份 :{{ showDate }}</div>
        <div>
          <el-dropdown style="margin-right: -45px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <RouteTarget :pathName="'month-ym-loss'">
            <span class="switch-table">明细</span>
          </RouteTarget>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域名称"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="periodName" label="养殖造次"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"> </el-table-column>
        <el-table-column label="本月排塘情况">
          <el-table-column prop="boxNum" label="塘口数"> </el-table-column>
          <el-table-column prop="lossNum" label="数量"> </el-table-column>
          <el-table-column prop="avgSpec" label="平均规格"> </el-table-column>
          <el-table-column prop="lossWeight" label="重量"> </el-table-column>
          <el-table-column prop="lossCost" label="损失成本"> </el-table-column>
        </el-table-column>
        <el-table-column label="本月累计排塘情况">
          <el-table-column prop="boxNumCy" label="塘口数"> </el-table-column>
          <el-table-column prop="lossNumCy" label="数量"> </el-table-column>
          <el-table-column prop="avgSpecCy" label="平均规格"> </el-table-column>
          <el-table-column prop="lossWeightCy" label="重量"> </el-table-column>
          <el-table-column prop="lossCostCy" label="损失成本">
          </el-table-column>
          <el-table-column prop="lossRateCy" label="排塘率%"> </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  searchMdtLossGroupList,
  exportOutPondGroupList,
  getCategoryConditions,
  getBreedConditions,
  getSeasonPeriodConditions,
} from "../ym-put/ym-put-service";
import {
  queryBaseDataListByRole,
  queryBaseGroupList,
} from "@/api/middle/common";
import Page from "@/utils/methods/page";
import RouteTarget from "@/components/pc/route-target.vue";
export default {
  name: "pond",
  components: { RouteTarget },
  data() {
    return {
      value: "",
      month: this.$moment().format("YYYY-MM"),
      PageDisplay: true,
      unitName: "", // 单位名称
      showDate: "", // 显示的日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "periodName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 10,
        orderBy: "desc",
        orderByName: "groupName",
        params: {
          baseId: "",
          orgId: "",
          breedTypeId: "",
          periodId: "",
          seedlingDataId: "",
          breedId: "",
          type: "M",
          year: "",
          startDate: this.$moment().format("YYYY-MM"),
          endDate: this.$moment().format("YYYY-MM"),
          breedTypeClass: "fish",
          groupId: "",
        },
      },
      exportParams: {}, // 导出参数
      tableData: [],
      baseList: [], // 养殖场列表
      groupList: [], // 分组列表
      periodList: [], // 造次列表
      breedTypeList: [], // 品类列表
      breedList: [], // 品种列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.orgId = localStorage.getItem("orgId");
    this.orgName = localStorage.getItem("orgName");
    // 养殖场
    queryBaseDataListByRole().then((res) => {
      if (res.code == "0000") {
        this.baseList = res.data;
      }
    });
    getSeasonPeriodConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.periodList = res.data;
      }
    });
    getCategoryConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.breedTypeList = res.data;
      }
    });
    getBreedConditions(
      this.params.params.orgId,
      this.params.params.breedTypeClass
    ).then((res) => {
      if (res.code == "0000") {
        this.breedList = res.data;
      }
    });
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 根据养殖场获取区域
    getGroupList(baseId) {
      this.params.params.groupId = "";
      this.groupList = [];
      if (!baseId) return
      this.params.params.groupId = "";
      queryBaseGroupList({
        baseId,
      }).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
    },
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val;
      this.params.params.endDate = val;
    },
    // 查询
    search() {
      this.getPageList();
    },
    // 初始化时间
    initTime() {
      this.params.params.startDate = "";
      this.params.params.endDate = "";
      this.params.params.baseId = "";
      this.params.params.groupId = "";
      this.params.params.periodId = "";
      this.params.params.breedTypeId = "";
      this.params.params.breedId = "";
      this.month = "";
      if (this.params.params.type == "M") {
        this.params.params.startDate = this.$moment().format("YYYY-MM");
        this.params.params.endDate = this.$moment().format("YYYY-MM");
        this.month = this.params.params.startDate;
      }
    },
    // 重置
    reset() {
      this.groupList = []
      this.initTime();
      this.getPageList();
    },
    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.breedTypeName === "合计") {
        return "heji-row";
      }
    },
    // 显示的单位-年-月
    showListData() {
      if (this.params.params.startDate) {
        this.showDate = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月"
        );
      }
    },
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      searchMdtLossGroupList(this.params).then((res) => {
        if (res.code == "0000") {
          this.tableData = res.data.list;
          this.showListData();
          this.exportParams = JSON.parse(JSON.stringify(this.params.params));
        }
        loading.close();
      });
    },
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(() => {
        this.exportParams.fileName = "养成投放概览排塘情况";
        Page.exportDatas(exportOutPondGroupList(), this.exportParams);
      });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
};
</script>

<style></style>